"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../../constants");
var paths = {
    OHLC_MINUTELY: '/ohlc/minutely',
    OHLC_HOURLY: '/ohlc/hourly',
    OHLC_DAILY: '/ohlc/daily',
    OHLC_WEEKLY: '/ohlc/weekly',
    COIN_TICKER: '/coin/data/ticker',
    PLATFORM: '/coin/data/platform',
    COIN_TYPE: '/coin/data/type',
    MOVERS: '/coin/data/movers',
    RATES: '/rates',
    CONVERTER: '/rates/convertor',
    ATHL: '/athl',
    METADATA_HISTORICAL: '/metadata/historical/coin/hourly',
    METADATA_AGGREGATED: '/metadata/historical/aggregated/hourly',
    EXCHANGES_SUMMARY: '/exchanges/summary',
};
var endpoints = {};
Object.keys(paths).forEach(function (key) {
    endpoints[key] = constants_1.BASE_MARKETS_URL + paths[key];
});
exports.default = endpoints;
